const question = {
    dynamic: { point: [3] },
    balanced: { point: [2] },
    prudent: { point: [1], resolvedProfile: 'P' },

};

export default question;
